module.exports = __webpack_public_path__ + "img/20.dcc7cc2a.png";